export default __webpack_public_path__ + "static/media/curators-wARroom3.899299df.png";